// extracted by mini-css-extract-plugin
export default {"container":"Works_container__1p4Ew","title":"Works_title__AN1zn","carouselContainer":"Works_carouselContainer__ouW3x"};